import Image from "next/image";
import { Interpolation, Theme, css, useTheme } from "@emotion/react";

export const Empty = ({
  imgurl,
  mainText,
  subText,
  ...props
}: {
  css?: Interpolation<Theme>;
  imgurl: string;
  mainText: string;
  subText?: string;
}) => {
  const theme = useTheme();

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 17vh;
      `}
      {...props}
    >
      <div
        css={css`
          position: relative;
          width: 140px;
          height: 140px;
          margin-bottom: 36px;

          @media (max-width: 768px) {
            width: 80px;
            height: 80px;
            margin-bottom: 24px;
          }
        `}
      >
        <Image alt="empty" fill={true} src={imgurl} />
      </div>
      {mainText && (
        <div
          css={css`
            font-size: 28px;
            font-weight: 500;
            line-height: 1;
            margin-bottom: 12px;

            @media (max-width: 768px) {
              font-size: 20px;
              margin-bottom: 8px;
            }
          `}
        >
          {mainText}
        </div>
      )}
      {subText && (
        <div
          css={css`
            font-size: 16px;
            line-height: 1.5;
            color: ${theme.color.grey_9};
            text-align: center;
            white-space: pre-wrap;

            @media (max-width: 768px) {
              font-size: 14px;
            }
          `}
        >
          {subText}
        </div>
      )}
    </div>
  );
};
